import * as _ from "lodash"

import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

import {WB_AffinitySetRow} from "../PA.Core/PAdbSchemaRows";
import {ASync} from "../PA.Core/Basic/ASync";


const vWB_AffinitySet_Fields:  {[id:string]: ISearchProviderField } = {
    WB_AFFINITYSET_ID:         {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Affinity WB Id',       columnResourceName: 'colCustWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
    AFFINITYSET_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Affinity Set Id',      columnResourceName: 'colCustId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
    AFFINITYSET_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Affinity Set Name',    columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    CANNIBALIZATION_TYPE_NAME: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Cannibalization Type', columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    CUSTOMER_LEVEL:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Level',       columnResourceName: 'colTreePath',     alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    PRODUCT_LEVEL:             {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Level',        columnResourceName: 'colTreePath',     alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}}
}

const vWB_AffinitySet_KeyFields =
    {id:    'WB_AFFINITYSET_ID',
     id_ui: 'AFFINITYSET_ID',
     name:  'AFFINITYSET_NAME'}


class AffinitySetSearchByListSearchProvider
    implements  ISearchProvider {

    arrWB_AffinitySetRows:WB_AffinitySetRow[] = []

    constructor(WB_AffinitySetRows: WB_AffinitySetRow[]){
        this.arrWB_AffinitySetRows = WB_AffinitySetRows
    }

    get keyFields() { return vWB_AffinitySet_KeyFields }

    get searchProviderFields(){
        return vWB_AffinitySet_Fields
    }

    search(requestSpec: ISearchRequestSubset): Promise<any[]> {
        return ASync.resolve(_.map(this.arrWB_AffinitySetRows, (aWB_AffinitySetRow: WB_AffinitySetRow) => {
            let aRow: any = aWB_AffinitySetRow.toJSON()
            aRow.CANNIBALIZATION_TYPE_NAME = aWB_AffinitySetRow?.WB_ModelCannibalizationTypeRow?.cif?.CANNIBALIZATION_TYPE_NAME || 'NA'
            aRow.PRODUCT_LEVEL = aWB_AffinitySetRow.cif.PRODUCT_LEVEL_ID
            aRow.CUSTOMER_LEVEL = aWB_AffinitySetRow.bItemHasCusotmer? '-': aWB_AffinitySetRow.cif.CUSTOMER_LEVEL_ID
            return aRow
        }))
    }

}


class AffinitySetSearchByListSearchProfile
    implements  ISearchProfile {

    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "AutoSearch Only"
    renderOptions = { ui5ResourceId: "AffinitySetSearchByListProfile" }

    profileFilter: IProfileFilter[] = []

    profileDisplayFields = [
        'AFFINITYSET_NAME','AFFINITYSET_ID', 'CANNIBALIZATION_TYPE_NAME', 'CUSTOMER_LEVEL','PRODUCT_LEVEL'
    ]

    profileTreeIdDefault = "default"
    profileTrees: ITree[] = [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [ new ColumnNodeProvider(['CANNIBALIZATION_TYPE_NAME'], {defaultValues: "No Cannibalization Type Set", levelDelimiter: "\\", ruggedTree: true})],
            renderOptions: {}}
    ]

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault = ""    //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];


    constructor(WB_AffinitySetRows: WB_AffinitySetRow[]){
        this.aSearchProvider = new AffinitySetSearchByListSearchProvider(WB_AffinitySetRows)
    }

    get profileSearchProvider(){ return this.aSearchProvider }

}


export class AffinitySetSearchByList
    implements  ISearch {

    constructor(WB_AffinitySetRows: WB_AffinitySetRow[], options?: any){
        this.searchProfiles = [ new AffinitySetSearchByListSearchProfile(WB_AffinitySetRows) ]
    }

    searchName = "Select Affinity Sets(s)"
    renderOptions = { ui5ResourceId: "AffinitySetSearchByList"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = true

}
